import { Button, Switch } from "@mui/material";
import { loadPercentageToggleState } from "store/features/analysisResultsSlice";
import { useSelector, useDispatch } from "react-redux";

const PercentageToggleComponent = () => {
    const dispatch = useDispatch();
    const percentageToggle = useSelector((state) => state.analysisResultsStore.percentageToggle);

    const handlePercentageToggleChange = () => {
        dispatch(loadPercentageToggleState(!percentageToggle));
    };

    return (
        <Button
            size="small"
            className="custom-btn custom-btn-outlined-2 color-blue bold-content ms-2 pb-1"
            variant="outlined"
        >
            Percentage
            <Switch
                size="small"
                checked={percentageToggle}
                onChange={handlePercentageToggleChange}
            />
        </Button>
    );
};

export default PercentageToggleComponent;
